define('modules/lists/modals/views/edit.contacts.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/base/models/identity.model',
    'modules/lists/modals/views/edit.contact.view'
], function(
    Prospector,
    $, _,Backbone,
    IdentityModel,
    ModalView
){
    var EditContactsView = ModalView.extend({
        index: 0,
        initialize: function(options) {
            this.debugName = 'Save identites to list view';
            this.identities = options.identities;
            this.name = options.name;
            this.mTitle = options.mTitle;
            this.contactType = options.contactType;
            ModalView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            this.justBuildModel();
        },
        justBuildModel:function(options){
            var that = this;
            require(['modules/base/models/identity.model'], function(IdentityModel){
                that.identityModel = new IdentityModel(that.identities[that.index]);
                if(options != undefined && options.passedFunc != undefined){
                    options.passedFunc();
                }
            });
        },
        onRender:function(){
            ModalView.prototype.onRender.call(this);
            this.procResponse();
        },
        procResponse:function(){
            this.$('.ripple').hide();
            this.$('.mainBtn').css('display', 'inline-block');
            this.$('.modal-body').show();
            if(this.name == undefined && this.mTitle == undefined){
                this.$('.modal-title').html('Save Profiles to a List');
            } else if(this.mTitle != undefined){
                this.$('.modal-title').html(this.mTitle);
            } else {
                this.$('.modal-title').html('Save ' + this.name + ' to a List');
            }
            if(window.entitlements.get('settings').allowSetContactType){
                this.$('.hasContactTypePriv').show();
                var stuff = this.$('.contactType .btn-default');
                switch(this.contactType){
                    case 'lead':{
                        $(stuff[1]).addClass('active');
                        break;
                    }
                    case 'prospect':{
                        $(stuff[2]).addClass('active');
                        break;
                    }
                    default:{
                        $(stuff[0]).addClass('active');
                        break;
                    }
                }
            } else {
                this.$('.hasContactTypePriv').remove();
            }
            this.$('.hasLists').show();
            var needsListName = this.name != undefined;
            var selectedValues = [];
            _.each(window.utils.getInternalLists(), function(list){
                if(list.name == this.name){
                    selectedValues.push(list.source.refId.toString());
                    needsListName = false;
                }
                this.$('.ui.dropdown .menu').append('<div class="item" data-source="1" data-value="' + list.source.refId+ '">' +list.name+ '</div>');
            }, this);
            if(needsListName){
                this.$('.ui.dropdown .menu').append('<div class="item" data-source="1" data-value="' + this.name+ '">' + this.name+ '</div>');
                selectedValues.push(this.name);
            }
            var that = this;
            this.$('.ui.dropdown').dropdown({
                allowAdditions: true,
                fullTextSearch: true,
                forceSelection: false,
                onHide:function(){
                    $(that.$('.ui.dropdown input')[1]).val("");
                }
            });
            window.setTimeout($.proxy(function(){
                this.$('.ui.dropdown').dropdown('set selected',selectedValues);
            }, this), 300);
        },
        passedNumListCheck:function(e){
            Prospector.trigger('createToast','Saving '+this.identityModel.getName()+' ('+ (this.index+1) +' of ' + this.identities.length + ')...');
            if(this.index == 0){
                this.closeModal();
                this.buildLists();
            }
            this.configModel();
        },
        procCreateLists:function(){
            this.index++;
            if(!this.identityModel.isValid()){
                this.errOut(this.identityModel.errorMessage);
            } else if(this.index < this.identities.length){
                this.justBuildModel({
                    passedFunc: $.proxy(function(){
                        this.passedNumListCheck();
                    }, this)
                });
            } else {
                this.mainBtnResponse();
                Prospector.trigger('createToast','Save to List Completed');
            }
        },
        procMainBtnResponse:function(){
            Prospector.trigger("clearToast");
            Prospector.trigger('refreshLists');
        }

    });
    return EditContactsView;
});


